import React from 'react'

const Input = ({label, data}) => {
  return (
    <div className='flex flex-col pt-[24px] md:pt-[26px]'>
        <label className='pb-[8px] text-[#334155] text-[12px] font-[600]'>{label}</label>
        <select className='px-[16px] py-[12px] rounded-[8px] border-2 border-[#94A3B8] outline-none'>
            {data.map((item, index) => {
                return (
                    <option key={index} value={item.name}>{item.name}</option>
                )
            })}
        </select>
    </div>
  )
}

export default Input